function initTopbarSlider() {
  const slider = document.querySelector(".topbar .slider");
  if (!slider) return; // Exit if slider doesn't exist
  
  const messages = Array.from(slider.querySelectorAll("span"));
  if (messages.length === 0) return; // Exit if no messages
  
  const sliderHeight = 24;
  let index = 0;
  let isMobile = window.innerWidth < 750;
  let intervalId = null;

  // For mobile: duplicate all messages to create seamless infinite scroll
  // For desktop: just clone the first message
  function setupSlider() {
    // Remove any previously cloned messages
    const clones = slider.querySelectorAll(".cloned");
    clones.forEach(clone => clone.remove());
    
    if (isMobile) {
      // Duplicate all messages multiple times for continuous scroll
      for (let i = 0; i < 3; i++) {
        messages.forEach(msg => {
          const clone = msg.cloneNode(true);
          clone.classList.add('cloned');
          slider.appendChild(clone);
        });
      }
      
      // Calculate the width of original content and set animation duration
      requestAnimationFrame(() => {
        const originalWidth = messages.reduce((sum, msg) => sum + msg.offsetWidth, 0);
        // Speed: 50px per second for smooth scrolling
        const duration = originalWidth / 25;
        slider.style.animationDuration = `${duration}s`;
        slider.classList.add('mobile-scroll');
      });
    } else {
      slider.classList.remove('mobile-scroll');
      slider.style.animationDuration = '';
      // Just clone first message for interval-based sliding
      const firstClone = messages[0].cloneNode(true);
      firstClone.classList.add('cloned');
      slider.appendChild(firstClone);
    }
  }

  function slideMessages() {
    if (isMobile) return; // No manual sliding on mobile
    
    index++;
    slider.style.transition = "transform 250ms ease-in-out";
    slider.style.transform = `translateY(-${index * sliderHeight}px)`;

    // Reset when the last (cloned) message is reached
    if (index === messages.length) {
      setTimeout(() => {
        slider.style.transition = "none";
        slider.style.transform = "translateY(0)";
        index = 0;
      }, 250);
    }
  }

  function startInterval() {
    if (intervalId) clearInterval(intervalId);
    if (!isMobile) {
      intervalId = setInterval(slideMessages, 5000);
    }
  }

  function handleResize() {
    const wasMobile = isMobile;
    isMobile = window.innerWidth < 750;
    
    if (wasMobile !== isMobile) {
      index = 0;
      slider.style.transition = "none";
      slider.style.transform = "translate(0, 0)";
      setupSlider();
      startInterval();
    }
  }

  setupSlider();
  startInterval();
  window.addEventListener('resize', handleResize);
}

// Handle both cases: DOMContentLoaded hasn't fired yet, or it has already fired
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTopbarSlider);
} else {
  // DOMContentLoaded has already fired
  initTopbarSlider();
}